import parse from "html-react-parser";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { GetContentsState } from "../../core/services/contentStringService/getContents/types";
import { IStore } from "../../core/utilities/reducers";
import "./ContentKey.scss";

interface IProps {
  key?: string;
  className?: string;
  contentKey: string;
  fallbackKey?: string;
  getContentsState: GetContentsState;
  onClick?: Function;
}

const ContentKey = (props: IProps) => {
  const getKey = (): string => {
    const contentKey = props.getContentsState.data.get(props.contentKey);
    if (contentKey) {
      return contentKey;
    }
    if (props.fallbackKey) {
      return (
        props.getContentsState.data.get(props.fallbackKey) ?? props.contentKey
      );
    }
    return props.contentKey;
  };

  return (
    <span
      id="content-key"
      key={props.key ?? props.contentKey}
      className={props.className ?? "key"}
      onClick={() => (props.onClick ? props.onClick() : {})}
    >
      {parse(getKey())}
    </span>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({}, dispatch);
};

const mapStateToProps = (store: IStore) => {
  return {
    getContentsState: store.getContents,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContentKey);
